import React from 'react';
import { Box } from '@mui/material';
import EmptyCompanyLogo from '../icons/EmptyCompanyLogo';

const CompanyLogo = ({ url, size = '40px', isCircle = true }) => {
  if (!isCircle) {
    if (!url) {
      return <EmptyCompanyLogo height={size} />;
    }

    return (
      <Box
        width={size}
        height={size}
        style={{
          backgroundImage: `url("${url}")`,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'white',
        }}
      />
    );
  }

  if (!url) {
    return (
      <Box
        width={size}
        height={size}
        borderRadius='50%'
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          overflow: 'hidden',
        }}
      >
        <EmptyCompanyLogo height={`calc(${size} - 15px)`} />
      </Box>
    );
  }

  return (
    <Box
      width={size}
      height={size}
      borderRadius='50%'
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        overflow: 'hidden',
      }}
    >
      <Box
        width={`calc(${size} - 15px)`}
        height={`calc(${size} - 10px)`}
        style={{
          backgroundImage: `url("${url}")`,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'white',
        }}
      />
    </Box>
  );
};

export default CompanyLogo;
